import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ShiftItem from "../components/shift/ShiftItem";
import NewShiftItem from "../components/shift/NewShiftItem";

import { StoreContext } from "shared/context/store-context";
import i18next from "i18next";
import Layout from "./shared/Layout";
import { days, days_en } from "shared/util/types";
import "./Admin.css";

const Shifts = () => {
  const { t } = useTranslation();
  const language = (i18next?.language || window?.localStorage?.i18nextLng || "en").substring(0, 2);

  const { shifts, UpdateShifts } = useContext(StoreContext);
  const itemType = "shift";
  const listName = "shifts";

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     UpdateShifts();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [UpdateShifts]);

  const standardHelpItems = [
    "1. Şu anda erişim yetkinizin olduğu personel vardiyaları sekmesini görüntülemektesiniz.",
    "2. Filtreleri kullanarak ilgili vardiyalara daha kolay erişim sağlayabilirsiniz.",
    "3. Sütun isimlerine tıklayarak sıralamayı değiştirebilirsiniz.",
    "4. Vardiyaları ayrıntıları görmek ve düzenlemek için ilgili satıra tıklayın.",
    "5. Yeni vardiya eklemek için 'Yeni Vardiya Yarat' butonuna tıklayın.",
  ];

  const highlightedHelpItems = [
    "1. Vardiya listeleri otomatik olarak güncellenmekte, personeller vardiyalara kendilerini ekleyebilmektedir.",
    "2. Liste ekranındaki personel sayısı her 60 saniyede otomatik olarak güncellenmektedir.",
    "3. Aynı şekilde vardiya ayrıntıları ekranındaki bilgiler de her 60 saniyede otomatik olarak güncellenmektedir.",
    "4. Kullanıcılar ile senkron olma zorunluluğundan dolayı, bir vardiya ayrıntısını değiştirmek istediğinizde bunu 60 saniyelik bir süre içerisinde yapmanız gerekmektedir.",
    "5. Güncellemek istediğiniz bilgiyi girerek güncelle tuşuna 60 saniye içerisinde basmamanız durumunda ekrana girdiğiniz bilgiler kaybolacak ve kayıtlı bilgiler ile güncellenmiş olacaktır.",
  ];

  const listColumns = [
    {
      field: "day",
      headerName: t("day"),
      width: 200,
      valueGetter: (params) => {
        try {
          return language === "en"
            ? days_en.find((day) => day.value.toString() === params.row.day.toString()).label
            : days.find((day) => day.value.toString() === params.row.day.toString()).label;
        } catch (e) {
          return "";
        }
      },
    },
    { field: "name", headerName: t("name"), width: 200 },
    { field: "description", headerName: t("description"), width: 300 },
    {
      field: "numberofpersonel",
      headerName: t("numberofpersonel"),
      width: 200,
      color: "red",
      valueGetter: (params) => {
        try {
          return params?.row?.users?.length?.toString() || "0";
        } catch (e) {
          return "Hata";
        }
      },
    },
    { field: "starttime", headerName: t("startTime"), width: 200 },
    { field: "endtime", headerName: t("endTime"), width: 200 },
  ];

  return (
    <React.Fragment>
      <Layout
        itemType={itemType}
        items={shifts}
        listName={listName}
        listColumns={listColumns}
        SelectedItemComponent={ShiftItem}
        NewItemComponent={NewShiftItem}
        standardHelpItems={standardHelpItems}
        highlightedHelpItems={highlightedHelpItems}
      />
    </React.Fragment>
  );
};

export default Shifts;
